import { ICellRendererParams, ICellEditorParams } from "ag-grid-community";
import React from "react";

import { SaleStatusBadge } from "components/Badge/SaleStatusBadge";

import { SaleStatusComponent } from "containers/UserDashboard/Cards/StatusSelect";

export function SaleStatusRenderer(params: ICellRendererParams) {
  if (!params.data || !params.data.livestockSale) {
    return params.getValue() || "";
  }

  const livesstockSaleId = params.data.livestockSale.id;

  return <SaleStatusComponent saleId={livesstockSaleId} forGrid />;
}

export function SaleStatusRendererFromSalesArray(params: ICellRendererParams) {
  const sales = params.data?.livestockSales;
  if (!sales?.length) {
    return params.getValue() || "";
  }

  const seen = new Set<string>();
  const badges: { label: string; color: string }[] = [];

  for (const sale of sales) {
    const { statusLabel, statusColor } = sale;
    if (!statusLabel) continue;
    const key = `${statusLabel}|${statusColor}`;
    if (!seen.has(key)) {
      seen.add(key);
      badges.push({ label: statusLabel, color: statusColor });
    }
  }

  return (
    <>
      {badges.map(({ label, color }) => (
        <SaleStatusBadge
          key={`${label}|${color}`}
          label={label}
          color={color}
          forGrid
        />
      ))}
    </>
  );
}

export function SaleStatusEditor(params: ICellEditorParams) {
  if (!params.data || !params.data.livestockSale) {
    return null;
  }

  const livesstockSaleId = params.data.livestockSale.id;

  const onEditComplete = () => {
    params.api.stopEditing();
  };

  return (
    <SaleStatusComponent
      saleId={livesstockSaleId}
      forGrid
      onEditComplete={onEditComplete}
    />
  );
}
